function t(t, r) {
  return function (t) {
    if (Array.isArray(t)) return t;
  }(t) || function (t, u) {
    var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
    if (null == r) return;
    var e,
        n,
        o = [],
        F = !0,
        i = !1;

    try {
      for (r = r.call(t); !(F = (e = r.next()).done) && (o.push(e.value), !u || o.length !== u); F = !0) {
        ;
      }
    } catch (t) {
      i = !0, n = t;
    } finally {
      try {
        F || null == r.return || r.return();
      } finally {
        if (i) throw n;
      }
    }

    return o;
  }(t, r) || u(t, r) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function u(t, u) {
  if (t) {
    if ("string" == typeof t) return r(t, u);
    var e = Object.prototype.toString.call(t).slice(8, -1);
    return "Object" === e && t.constructor && (e = t.constructor.name), "Map" === e || "Set" === e ? Array.from(t) : "Arguments" === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? r(t, u) : void 0;
  }
}

function r(t, u) {
  (null == u || u > t.length) && (u = t.length);

  for (var r = 0, e = new Array(u); r < u; r++) {
    e[r] = t[r];
  }

  return e;
}

var e = /\.(?:(?:[\x2D0-9A-Z_a-z\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|\\(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))+/,
    n = /#(?:(?:[\x2D0-9A-Z_a-z\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|\\(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))+/,
    o = /\[[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*((?:(?:\*|[\x2D0-9A-Z_a-z]*)\|)?(?:(?:[\x2D0-9A-Z_a-z\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+))/g,
    F = {};

function i(r) {
  var i = F[r];
  if (i) return i;
  i = F[r] = {
    attributes: !0,
    subtree: !0,
    childList: !0
  };

  var a,
      l = [],
      c = function (t, r) {
    var e = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];

    if (!e) {
      if (Array.isArray(t) || (e = u(t)) || r && t && "number" == typeof t.length) {
        e && (t = e);

        var _n = 0,
            o = function o() {};

        return {
          s: o,
          n: function n() {
            return _n >= t.length ? {
              done: !0
            } : {
              done: !1,
              value: t[_n++]
            };
          },
          e: function e(t) {
            throw t;
          },
          f: o
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var F,
        i = !0,
        a = !1;
    return {
      s: function s() {
        e = e.call(t);
      },
      n: function n() {
        var t = e.next();
        return i = t.done, t;
      },
      e: function e(t) {
        a = !0, F = t;
      },
      f: function f() {
        try {
          i || null == e.return || e.return();
        } finally {
          if (a) throw F;
        }
      }
    };
  }(r.matchAll(o));

  try {
    for (c.s(); !(a = c.n()).done;) {
      var D = t(a.value, 2)[1];
      if (D.startsWith("*") || D.startsWith("|")) return i;
      l.push(D.replace("|", ":"));
    }
  } catch (t) {
    c.e(t);
  } finally {
    c.f();
  }

  return e.test(r) && l.push("class"), n.test(r) && l.push("id"), 0 === l.length ? i.attributes = !1 : i.attributeFilter = l, i;
}

function a(t) {
  var u = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = u.timeout,
      e = void 0 === r ? 2500 : r,
      n = u.scope,
      o = void 0 === n ? document : n;
  return new Promise(function (u) {
    var r = o.querySelector(t);

    if (null === r) {
      var n = null,
          F = new MutationObserver(function () {
        var r = o.querySelector(t);
        null !== r && (clearTimeout(n), F.disconnect(), u(r));
      });
      F.observe(o, i(t)), n = setTimeout(function () {
        F.disconnect(), u(null);
      }, e);
    } else u(r);
  });
}

function l(t) {
  var u = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = u.timeout,
      e = void 0 === r ? 2500 : r,
      n = u.scope,
      o = void 0 === n ? document : n;
  return new Promise(function (u) {
    var r = null;

    if (null !== o.querySelector(t)) {
      var n = new MutationObserver(function () {
        null === o.querySelector(t) && (clearTimeout(r), n.disconnect(), u(!0));
      });
      n.observe(o, i(t)), r = setTimeout(function () {
        n.disconnect(), u(!1);
      }, e);
    } else u(!0);
  });
}

export { a as waitForTheElement, l as waitForTheElementToDisappear };